import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useEmpresasLanguage } from "../../context/EmpresasLanguageContext";
import { cezNoticias } from "../../data/cezNoticias";

function CezNoticiasSection({ title, intro, verMas }) {
  const { lang } = useEmpresasLanguage();
  const noticias = cezNoticias[lang] || cezNoticias.es;

  return (
    <section className="py-16 px-6 sm:px-10 lg:px-16 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-[0.12em] text-[#0b1f3f]">
            {title}
          </h2>
          {intro && <p className="mt-4 text-slate-600 text-base sm:text-lg leading-relaxed">{intro}</p>}
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {noticias.map((noticia) => (
            <article
              key={noticia.slug}
              className="group flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:shadow-md"
            >
              <Link to={noticia.path} className="block overflow-hidden">
                <img
                  src={noticia.imagen}
                  alt={noticia.titulo}
                  className="h-44 w-full object-cover object-center transition duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </Link>
              <div className="flex flex-1 flex-col p-5">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#1746a2]">
                  {noticia.categoria}
                </p>
                <h3 className="mt-2 text-lg font-extrabold leading-snug text-[#0b1f3f]">
                  <Link to={noticia.path} className="hover:text-[#1746a2] transition">
                    {noticia.titulo}
                  </Link>
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600 line-clamp-4">
                  {noticia.resumen}
                </p>
                <Link
                  to={noticia.path}
                  className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-[#1746a2] hover:gap-3 transition-all"
                >
                  {verMas}
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CezNoticiasSection;
